import { Text, ScreenContainer, View } from "@src/components";
import { sizes } from "@src/constants/sizes";
import { PressableScale } from "pressto";
import { NumericKeyboard } from "@src/components/Pin/NumericKeyboard";
import { PinDots } from "@src/components/Pin/PinDots";
import { usePin } from "@src/hooks/usePin";
import { StyleSheet } from "react-native-unistyles";
import { FocusedSystemBars } from "@src/components/FocusedSystemBars";
import { BackgroundGradient } from "@src/components/BackgroundGradient";
import { BackRoundedButton } from "@src/components/BackRoundedButton";
import { ContactUsButton } from "@src/components/ContactUsButton";
import { router, useLocalSearchParams } from "expo-router";
import { useCallback, useEffect } from "react";
import { track } from "@visioni/a3s-analytics";
import { PinSetupStarted, pinFlowFromParam } from "@src/features/auth/analytics";
import { AppStorageKeys, BiometricPreference, useStorage } from "@src/services/app-storage";

const PinScreen = () => {
  const flow = pinFlowFromParam(useLocalSearchParams().flow);
  const { pin, onChangePin, onDeletePin } = usePin({ flow });
  const [, setBiometricPreference] = useStorage<BiometricPreference>(AppStorageKeys.BIOMETRIC_PREFERENCE);

  // Track when PIN setup screen is opened
  useEffect(() => {
    if (flow === "setup") track(PinSetupStarted);
  }, [flow]);

  const handleSkip = useCallback(() => {
    setBiometricPreference({ biometricEnabled: true });
    router.replace("/onboarding/push-notifications");
  }, [setBiometricPreference]);

  return (
    <>
      <FocusedSystemBars style="light" />
      <BackgroundGradient>
        <ScreenContainer
          edges={["top", "bottom"]}
          style={{ backgroundColor: "transparent" }}
          contentMaxWidth={sizes.maxWidthSm}
          scrollable
        >
          <View flexDirection="row" justifyContent={router.canGoBack() ? "space-between" : "flex-end"}>
            {router.canGoBack() && <BackRoundedButton onPress={() => router.back()} />}

            <PressableScale onPress={handleSkip}>
              <Text textStyle="md/regular" style={styles.secondaryText}>
                Skip
              </Text>
            </PressableScale>
          </View>
          <View mt="9xl" alignItems="center">
            <Text textStyle="h3/regular" textAlign="center" style={styles.text}>
              Set up Passcode
            </Text>
          </View>
          <View mt="4xl" alignItems="center">
            <PinDots pinLength={pin.length} />
          </View>
          <View flex={1} alignItems="center">
            <NumericKeyboard
              enabled={!(pin.length === 4)}
              onPress={onChangePin}
              onDelete={() => onDeletePin({ isConfirmPin: false })}
            />
          </View>
          <View
            mb="xl"
            px="4xl"
            flexDirection="row"
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
            gap="sm"
          >
            <Text textStyle="sm/regular" textAlign="center" style={styles.text}>
              Having a problem?
            </Text>
            <ContactUsButton />
          </View>
        </ScreenContainer>
      </BackgroundGradient>
    </>
  );
};

const styles = StyleSheet.create((theme) => ({
  text: {
    color: theme.colors.interactive.buttons.default_foreground,
  },
  secondaryText: {
    color: theme.colors.interactive.controls.secondary_foreground,
  },
}));
export default PinScreen;
